import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Aún no se ha generado ninguna ronda", -1)
const _hoisted_5 = [
  _hoisted_4
]

import { compartirSistemaAleman } from "@/composables/useSistemaAleman";
import SelectorRondas from "@/components/Commons/SelectorRondas.vue";
import { useRondasEnPestana } from "@/composables/useRondasEnPestana";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import CardEmparejamientos from "@/components/GestionTorneos/Equipos/CardEmparejamientos.vue";
import TabClasificacionEquipos from "@/components/GestionTorneos/Equipos/TabClasificacionEquipos.vue";
import TabClasificacionEquiposIndividual from "@/components/GestionTorneos/Equipos/TabClasificacionEquiposIndividual.vue";
import TabMostrarListas from "@/components/GestionTorneos/TabMostrarListas.vue";
import TabResumenTorneo from "@/components/GestionTorneos/TabResumenTorneo.vue";
import CardPartidaGestion from "@/components/GestionTorneos/CardPartidaGestion.vue";
import { useAuth } from "@/composables/useAuth";
import {
  ResultMatchMatchedPlayType,
  MatchResultPoint,
  ResultMatchMatchedPlayExtendedTeamType,
  MatchResultGeneral,
} from "@/Constant/TipoClasificacion";
import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import { Clasificacion } from "@/interfaces/Live";
import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import {
  ClasificacionEquipo,
  InscripcionTorneoCreadoDTO,
  ResumenTorneoDTO,
  Torneo,
} from "@/interfaces/Torneo";
import { getInscripcionesTorneo } from "@/services/InscripcionesService";
import {
  getInfoTorneoEquipoCreado,
  getPartidasTorneo,
  getResumenTorneoAsync,
  getTorneo,
} from "@/services/TorneosService";
import { appsettings } from "@/settings/appsettings";
import { calcularPuntosAleman } from "@/utils/sistemaAleman";
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";

const TAB_RESUMEN = -1;

export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleTorneoLiveEquiposView',
  setup(__props) {

const route = useRoute();
const idTorneo = ref<number>(Number(route.params.idTorneo));
const isLoading = ref<boolean>(false);
const isLoadingImage = ref<boolean>(false);
const torneo = ref<Torneo>();
// Con el sistema alemán, las partidas enseñan también los puntos que dan
compartirSistemaAleman(() => torneo.value?.classificationType);
const partidas = ref<PartidaTorneoDTO[]>([]);
const misPartidas = ref<PartidaTorneoDTO[]>([]);
const numeroRondas = ref<number[]>([]);
const partidasPorRonda = ref<Record<number, PartidaTorneoDTO[]>>({});
const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<string | null>(getidUsuario.value);
const idUsuario = ref<number>();
const idEquipo = ref<number | null>(null);
const activeTab = ref<number>();
const tabClasificacion = ref<number>();
const tabClasificacionIndividual = ref<number>();
const tabListas = ref<number>();
const tabMisPartidas = ref<number>();
const clasificacion = ref<Clasificacion[]>([]);
const jugadoresZona1 = ref<Clasificacion[]>([]);
const jugadoresZona2 = ref<Clasificacion[]>([]);
const clasificacionDividida = ref<Clasificacion[]>([]);
const clasificacionZona1 = ref<Clasificacion[]>([]);
const clasificacionZona2 = ref<Clasificacion[]>([]);
const torneoGestion = ref<TorneoEquipoGestionInfoDTO | null>(null);
const clasificacionEquipos = ref<ClasificacionEquipo[]>([]);
const inscripciones = ref<InscripcionTorneoCreadoDTO[]>([]);
const resumen = ref<ResumenTorneoDTO | null>(null);
const isLoadingPartidas = ref(true);
const podioEquipos = computed(() =>
  clasificacionEquipos.value.slice(0, 3).map(e => e.nombreEquipo)
);

function manejarClasificacion(clasificacion: ClasificacionEquipo[]) {
  clasificacionEquipos.value = clasificacion;
}

onMounted(async () => {
  if (idUsuarioLogger.value) idUsuario.value = parseInt(idUsuarioLogger.value);
  isLoading.value = true;

  // Llamadas críticas en paralelo: en cuanto respondan se muestra la vista
  const [resTorneo, resResumen] = await Promise.allSettled([
    getTorneo(idTorneo.value),
    getResumenTorneoAsync(idTorneo.value),
  ]);

  if (resTorneo.status === "fulfilled") {
    torneo.value = resTorneo.value.data;
    numeroRondas.value = Array.from(
      { length: torneo.value?.numeroPartidas ?? 0 },
      (_, index) => index + 1
    );
    tabClasificacion.value = numeroRondas.value.length + 2;
    tabClasificacionIndividual.value = numeroRondas.value.length + 3;
    tabListas.value = numeroRondas.value.length + 1;
    tabMisPartidas.value = 0;
  }

  if (resResumen.status === "fulfilled") {
    resumen.value = resResumen.value.data;
  }

  activeTab.value = TAB_RESUMEN;
  isLoading.value = false;

  // Llamadas secundarias en background — actualizan reactivamente
  Promise.allSettled([
    getPartidasTorneo(idTorneo.value),
    getInfoTorneoEquipoCreado(idTorneo.value),
    getInscripcionesTorneo(idTorneo.value),
  ]).then(([resPartidas, resTorneoGestion, resInscripciones]) => {
    if (resTorneoGestion.status === "fulfilled") {
      torneoGestion.value = resTorneoGestion.value.data;
      for (const equipo of (torneoGestion.value?.equipos ?? [])) {
        if (equipo.inscripciones.some(ins => ins.idUsuario === idUsuario.value)) {
          idEquipo.value = equipo.idEquipo;
        }
      }
    }
    if (resPartidas.status === "fulfilled") {
      partidas.value = resPartidas.value.data;
      partidasPorRonda.value = partidas.value.reduce(
        (acc, partida) => {
          const { numeroRonda } = partida;
          if (!acc[numeroRonda]) acc[numeroRonda] = [];
          acc[numeroRonda].push(partida);
          return acc;
        },
        {} as Record<number, PartidaTorneoDTO[]>
      );
      misPartidas.value = partidas.value.filter(
        p => p.idEquipo1 == idEquipo.value || p.idEquipo2 == idEquipo.value
      );
    }
    if (resInscripciones.status === "fulfilled") {
      inscripciones.value = resInscripciones.value.data;
    }
    // Necesita las inscripciones cargadas para sumar los puntosExtra
    if (resPartidas.status === "fulfilled") calcularClasificacion();
    isLoadingPartidas.value = false;
  });
});

const calcularClasificacion = async () => {
  const ranking: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      empates: number;
      derrotas: number;
      puntosTorneo: number;
      idTorneo: number;
    }
  > = {};
  const rankingDividido: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      empates: number;
      derrotas: number;
      puntosTorneo: number;
      idTorneo: number;
    }
  > = {};

  // Filtramos hasta la ronda 2 para dividir el grupo
  const partidasFiltradas = partidas.value?.filter(
    partida => partida.numeroRonda <= 2
  );

  partidasFiltradas?.forEach(partida => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!rankingDividido[partida.idUsuario1]) {
        rankingDividido[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
          idTorneo: partida.idTorneo,
        };
      }
      if (!rankingDividido[partida.idUsuario2]) {
        rankingDividido[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
          idTorneo: partida.idTorneo,
        };
      }

      // Actualizamos puntos a favor y en contra
      rankingDividido[partida.idUsuario1].puntosFavor += puntosUsuario1;
      rankingDividido[partida.idUsuario1].puntosContra += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosFavor += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      rankingDividido[partida.idUsuario1].diferenciaPuntos =
        rankingDividido[partida.idUsuario1].puntosFavor -
        rankingDividido[partida.idUsuario1].puntosContra;
      rankingDividido[partida.idUsuario2].diferenciaPuntos =
        rankingDividido[partida.idUsuario2].puntosFavor -
        rankingDividido[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (torneo.value?.classificationType === 1) {
        //CLASIFICACION TIPO NORMAL
        if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          rankingDividido[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          rankingDividido[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
      } else if (torneo.value?.classificationType === 2) {
        //CLASIFICACION TIPO EXTENDED
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 === res2) {
          rankingDividido[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayExtendedTeamType.DRAW;
          rankingDividido[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayExtendedTeamType.DRAW;
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        } else {
          if (res1 > res2) {
            if (res1 >= 2 * res2 && res1 >= 6) {
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_WIN;
              rankingDividido[partida.idUsuario1].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario2].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_LOSS;
            } else {
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_WIN;
              rankingDividido[partida.idUsuario1].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario2].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_LOSS;
            }
          }
          if (res2 > res1) {
            if (res2 >= 2 * res1 && res2 >= 6) {
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_WIN;
              rankingDividido[partida.idUsuario2].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario1].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_LOSS;
            } else {
              rankingDividido[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_WIN;
              rankingDividido[partida.idUsuario2].victorias +=
                MatchResultPoint.WIN;
              rankingDividido[partida.idUsuario1].derrotas +=
                MatchResultPoint.LOSS;
              rankingDividido[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_LOSS;
            }
          }
        }
      } else if (torneo.value?.classificationType === 3) {
        //CLASIFICACION TIPO ALEMAN
        // Sistema alemán: la suma de puntos de ambos jugadores es 20
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 > res2) {
          rankingDividido[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (res2 > res1) {
          rankingDividido[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          rankingDividido[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          rankingDividido[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          rankingDividido[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
        const { jugador1, jugador2 } = calcularPuntosAleman(res1, res2);
        rankingDividido[partida.idUsuario1].puntosTorneo += jugador1;
        rankingDividido[partida.idUsuario2].puntosTorneo += jugador2;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        rankingDividido[partida.idUsuario1].lider += MatchResultGeneral.DEAD;
      }
      if (liderMuertoUsuario2) {
        rankingDividido[partida.idUsuario2].lider += MatchResultGeneral.DEAD;
      }
    }
  });

  clasificacionDividida.value = Object.values(rankingDividido).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  dividirClasificacionEnZonas();

  // CLASIFICACION GENERAL
  partidas.value?.forEach(partida => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!ranking[partida.idUsuario1]) {
        ranking[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
          idTorneo: partida.idTorneo,
        };
      }
      if (!ranking[partida.idUsuario2]) {
        ranking[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
          idTorneo: partida.idTorneo,
        };
      }

      // Actualizamos puntos a favor y en contra
      ranking[partida.idUsuario1].puntosFavor += puntosUsuario1;
      ranking[partida.idUsuario1].puntosContra += puntosUsuario2;
      ranking[partida.idUsuario2].puntosFavor += puntosUsuario2;
      ranking[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      ranking[partida.idUsuario1].diferenciaPuntos =
        ranking[partida.idUsuario1].puntosFavor -
        ranking[partida.idUsuario1].puntosContra;
      ranking[partida.idUsuario2].diferenciaPuntos =
        ranking[partida.idUsuario2].puntosFavor -
        ranking[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (torneo.value?.classificationType === 1) {
        //CLASIFICACION TIPO NORMAL
        if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.WIN;
          ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayType.DRAW;
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
      } else if (torneo.value?.classificationType === 2) {
        //CLASIFICACION TIPO EXTENDED
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 === res2) {
          ranking[partida.idUsuario1].puntosTorneo +=
            ResultMatchMatchedPlayExtendedTeamType.DRAW;
          ranking[partida.idUsuario2].puntosTorneo +=
            ResultMatchMatchedPlayExtendedTeamType.DRAW;
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        } else {
          if (res1 > res2) {
            if (res1 >= 2 * res2 && res1 >= 6) {
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_WIN;
              ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_LOSS;
            } else {
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_WIN;
              ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_LOSS;
            }
          }
          if (res2 > res1) {
            if (res2 >= 2 * res1 && res2 >= 6) {
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_WIN;
              ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MAJOR_LOSS;
            } else {
              ranking[partida.idUsuario2].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_WIN;
              ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
              ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
              ranking[partida.idUsuario1].puntosTorneo +=
                ResultMatchMatchedPlayExtendedTeamType.MINOR_LOSS;
            }
          }
        }
      } else if (torneo.value?.classificationType === 3) {
        //CLASIFICACION TIPO ALEMAN
        // Sistema alemán: la suma de puntos de ambos jugadores es 20
        const res1 = partida.resultadoUsuario1 ?? 0;
        const res2 = partida.resultadoUsuario2 ?? 0;
        if (res1 > res2) {
          ranking[partida.idUsuario1].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario2].derrotas += MatchResultPoint.LOSS;
        } else if (res2 > res1) {
          ranking[partida.idUsuario2].victorias += MatchResultPoint.WIN;
          ranking[partida.idUsuario1].derrotas += MatchResultPoint.LOSS;
        } else {
          ranking[partida.idUsuario1].empates += MatchResultPoint.DRAW;
          ranking[partida.idUsuario2].empates += MatchResultPoint.DRAW;
        }
        const { jugador1, jugador2 } = calcularPuntosAleman(res1, res2);
        ranking[partida.idUsuario1].puntosTorneo += jugador1;
        ranking[partida.idUsuario2].puntosTorneo += jugador2;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        ranking[partida.idUsuario1].lider += MatchResultGeneral.DEAD;
      }
      if (liderMuertoUsuario2) {
        ranking[partida.idUsuario2].lider += MatchResultGeneral.DEAD;
      }
    }
  });

  inscripciones.value.forEach(inscripcion => {
    const userId = inscripcion.idUsuario;
    if (ranking[userId]) {
      ranking[userId].puntosTorneo += inscripcion.puntosExtra;
    }
  });

  clasificacion.value = Object.values(ranking).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  // Clasificacion por zonas
  clasificacionZona1.value = clasificacion.value.filter(jugador =>
    jugadoresZona1.value.some(z => z.idUsuario === jugador.idUsuario)
  );

  clasificacionZona2.value = clasificacion.value.filter(jugador =>
    jugadoresZona2.value.some(z => z.idUsuario === jugador.idUsuario)
  );

  type JugadorConEjercito = {
    nick: string;
    ejercito: string | null;
  };

  const jugadoresConEjercitos = partidas.value.reduce<JugadorConEjercito[]>(
    (acc, partida) => {
      // Solo las que tienen ejército: en la primera ronda puede faltar si aún no había entregado la lista
      if (partida.ejercitoUsuario1)
        acc.push({ nick: partida.nick1, ejercito: partida.ejercitoUsuario1 });
      if (partida.ejercitoUsuario2)
        acc.push({ nick: partida.nick2, ejercito: partida.ejercitoUsuario2 });
      return acc;
    },
    []
  );

  const listaEjercitos = appsettings.armies;

  const ejercitosJugadoresConBando = jugadoresConEjercitos.map(jugador => {
    const ejercito = listaEjercitos.find(e => e.name === jugador.ejercito);
    return {
      nick: jugador.nick,
      ejercito: jugador.ejercito,
      bando: ejercito ? ejercito.band : "desconocido",
      shortName: ejercito?.shortName,
    };
  });

  clasificacion.value = clasificacion.value.map(j => {
    const datosEjercito = ejercitosJugadoresConBando.find(
      e => e.nick === j.nick
    );
    return {
      ...j,
      bando: datosEjercito?.bando ?? "desconocido",
      nombreCortoEjercito: datosEjercito?.shortName ?? undefined,
      ejercito: datosEjercito?.ejercito ?? undefined,
    };
  });
};

const dividirClasificacionEnZonas = () => {
  const totalJugadores = clasificacionDividida.value.length;
  const esImpar = totalJugadores % 2 !== 0;

  const mitad = Math.floor(totalJugadores / 2);
  const zona1Size = esImpar ? mitad + 1 : mitad;

  jugadoresZona1.value = clasificacionDividida.value.slice(0, zona1Size);
  jugadoresZona2.value = clasificacionDividida.value.slice(zona1Size);
};

//Este método determina si el jugador actual ha validado ya la partida o no.
const editarPartidaCapitan = (partida: PartidaTorneoDTO) => {
  if (
    partida.idCapitan1 === idUsuario.value &&
    (partida.partidaValidadaUsuario1 === false ||
      partida.partidaValidadaUsuario1 === null)
  ) {
    return true;
  } else if (
    partida.idCapitan2 === idUsuario.value &&
    (partida.partidaValidadaUsuario2 === false ||
      partida.partidaValidadaUsuario2 === null)
  ) {
    return true;
  } else {
    return false;
  }
};

const soloValidarCapitan = (partida: PartidaTorneoDTO) => {
  //Si somos el Capitan1 y no hemos validado partida, y el Capitan si ha validado, tenemos que validar
  if (
    partida.idCapitan1 === idUsuario.value &&
    (partida.partidaValidadaUsuario1 === false ||
      partida.partidaValidadaUsuario1 === null) &&
    partida.partidaValidadaUsuario2 === true
  ) {
    return true;
  } else if (
    partida.idCapitan2 === idUsuario.value &&
    (partida.partidaValidadaUsuario2 === false ||
      partida.partidaValidadaUsuario2 === null) &&
    partida.partidaValidadaUsuario1 === true
  ) {
    return true;
  } else {
    return false;
  }
};

// Las rondas en una sola pestaña: activeTab sigue siendo el número de ronda
const {
  pestana,
  enRondas,
  TAB_RONDAS,
  jugadorBuscado,
  jugadores,
  deLaBusqueda,
  equiposDelBuscado,
  mesaDe,
} = useRondasEnPestana(
  activeTab,
  numeroRondas,
  partidasPorRonda
);

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { class: "pa-4" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingGandalf)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_tabs, {
              modelValue: _unref(pestana),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pestana) ? (pestana).value = $event : null)),
              "show-arrows": "",
              grow: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_v_tab, {
                  key: -1,
                  text: "Resumen",
                  value: -1
                })),
                (misPartidas.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: tabMisPartidas.value,
                      text: `Mis partidas`,
                      value: tabMisPartidas.value
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_tab, {
                  value: _unref(TAB_RONDAS),
                  text: "Rondas"
                }, null, 8, ["value"]),
                (_openBlock(), _createBlock(_component_v_tab, {
                  key: tabListas.value,
                  text: `Listas`,
                  value: tabListas.value
                }, null, 8, ["value"])),
                (_openBlock(), _createBlock(_component_v_tab, {
                  key: tabClasificacion.value,
                  text: `Clasificación`,
                  value: tabClasificacion.value
                }, null, 8, ["value"])),
                (torneo.value?.tipoTorneo !== 'Parejas')
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: tabClasificacionIndividual.value,
                      text: `Individual`,
                      value: tabClasificacionIndividual.value
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (activeTab.value !== -1)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  variant: "text",
                  size: "small",
                  "prepend-icon": "mdi-arrow-left",
                  class: "mt-1 mb-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = -1))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Resumen")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(enRondas))
              ? (_openBlock(), _createBlock(SelectorRondas, {
                  key: 1,
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event)),
                  rondas: numeroRondas.value,
                  partidasPorRonda: partidasPorRonda.value,
                  jugador: _unref(jugadorBuscado),
                  "onUpdate:jugador": _cache[3] || (_cache[3] = ($event: any) => (_isRef(jugadorBuscado) ? (jugadorBuscado).value = $event : null)),
                  jugadores: _unref(jugadores)
                }, null, 8, ["modelValue", "rondas", "partidasPorRonda", "jugador", "jugadores"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_window, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((activeTab).value = $event))
            }, {
              default: _withCtx(() => [
                (!isLoadingPartidas.value && partidas.value.length === 0 && activeTab.value !== -1 && activeTab.value !== tabListas.value && activeTab.value !== tabClasificacion.value && activeTab.value !== tabClasificacionIndividual.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                  : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_component_v_window_item, {
                  value: -1,
                  key: -1
                }, {
                  default: _withCtx(() => [
                    (resumen.value)
                      ? (_openBlock(), _createBlock(TabResumenTorneo, {
                          key: 0,
                          resumen: resumen.value,
                          isLoadingPartidas: isLoadingPartidas.value,
                          tipoTorneo: torneo.value?.tipoTorneo,
                          podioEquipos: podioEquipos.value,
                          idTorneo: idTorneo.value,
                          nombreTorneo: torneo.value?.nombreTorneo,
                          onGoListas: _cache[4] || (_cache[4] = ($event: any) => (activeTab.value = tabListas.value)),
                          onGoClasificacion: _cache[5] || (_cache[5] = ($event: any) => (activeTab.value = tabClasificacion.value)),
                          onGoRonda: _cache[6] || (_cache[6] = (n) => (activeTab.value = n))
                        }, null, 8, ["resumen", "isLoadingPartidas", "tipoTorneo", "podioEquipos", "idTorneo", "nombreTorneo"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })),
                (_openBlock(), _createBlock(_component_v_window_item, {
                  value: tabMisPartidas.value,
                  key: tabMisPartidas.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "mb-0" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(misPartidas.value, (partida) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            cols: "12",
                            sm: "12",
                            md: "6",
                            lg: "6",
                            xl: "4",
                            class: "pb-0",
                            key: partida.idPartidaTorneo
                          }, {
                            default: _withCtx(() => [
                              _createVNode(CardPartidaGestion, {
                                partida: partida,
                                editable: false,
                                etiqueta: `Ronda ${partida.numeroRonda}`,
                                idJugador: parseInt(idUsuarioLogger.value!),
                                meterResultado: editarPartidaCapitan(partida),
                                soloValidar: soloValidarCapitan(partida),
                                listaPorPareja: torneo.value?.listaPorPareja === true,
                                cambiarPairing: ""
                              }, null, 8, ["partida", "etiqueta", "idJugador", "meterResultado", "soloValidar", "listaPorPareja"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numeroRondas.value, (n) => {
                  return (_openBlock(), _createBlock(_component_v_window_item, {
                    key: n,
                    value: n
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "mb-0" }, {
                        default: _withCtx(() => [
                          (isLoadingPartidas.value)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                class: "d-flex justify-center pa-8"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    color: "primary"
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (torneo.value?.tipoTorneo !== 'Individual')
                                  ? (_openBlock(), _createBlock(CardEmparejamientos, {
                                      key: 0,
                                      partidas: partidas.value,
                                      soloEquipos: _unref(equiposDelBuscado),
                                      numeroRonda: n
                                    }, null, 8, ["partidas", "soloEquipos", "numeroRonda"]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deLaBusqueda)(partidasPorRonda.value[n]), (partida) => {
                                  return (_openBlock(), _createBlock(_component_v_col, {
                                    cols: "12",
                                    sm: "12",
                                    md: "6",
                                    lg: "6",
                                    xl: "4",
                                    class: "pb-0",
                                    key: partida.idPartidaTorneo
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(CardPartidaGestion, {
                                        partida: partida,
                                        editable: false,
                                        etiqueta: `Mesa ${_unref(mesaDe)(partidasPorRonda.value[n], partida)}`,
                                        idJugador: parseInt(idUsuarioLogger.value!),
                                        meterResultado: editarPartidaCapitan(partida),
                                        soloValidar: soloValidarCapitan(partida),
                                        listaPorPareja: torneo.value?.listaPorPareja === true,
                                        cambiarPairing: ""
                                      }, null, 8, ["partida", "etiqueta", "idJugador", "meterResultado", "soloValidar", "listaPorPareja"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ], 64))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128)),
                (_openBlock(), _createBlock(_component_v_window_item, {
                  value: tabListas.value,
                  key: tabListas.value
                }, {
                  default: _withCtx(() => [
                    (torneo.value?.mostrarListas)
                      ? (_openBlock(), _createBlock(TabMostrarListas, {
                          key: 0,
                          torneo: torneo.value
                        }, null, 8, ["torneo"]))
                      : (_openBlock(), _createBlock(_component_v_alert, {
                          key: 1,
                          type: "info",
                          variant: "tonal",
                          class: "ma-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Las listas están ocultas")
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["value"])),
                _createVNode(TabClasificacionEquipos, {
                  tabClasificacion: tabClasificacion.value,
                  activeTab: activeTab.value!,
                  torneo: torneo.value,
                  partidas: partidas.value,
                  equipos: torneoGestion.value?.equipos,
                  mostrarClasificacion: torneo.value?.mostrarClasificacion,
                  onEnviarClasificacion: manejarClasificacion
                }, null, 8, ["tabClasificacion", "activeTab", "torneo", "partidas", "equipos", "mostrarClasificacion"]),
                _createVNode(TabClasificacionEquiposIndividual, {
                  tabClasificacion: tabClasificacionIndividual.value,
                  activeTab: activeTab.value!,
                  clasificacion: clasificacion.value,
                  mostrarClasificacion: torneo.value?.mostrarClasificacion,
                  onEnviarClasificacion: manejarClasificacion
                }, null, 8, ["tabClasificacion", "activeTab", "clasificacion", "mostrarClasificacion"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])),
      _createVNode(_component_v_dialog, {
        modelValue: isLoadingImage.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isLoadingImage).value = $event)),
        persistent: "",
        width: "300"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: "d-flex justify-center align-center",
                style: {"height":"150px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "blue-lighten-3",
                    size: 57
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})